import React, { Component, createRef } from 'react';
import discordicon from '../photos/discordicon.png';
//import tiktokicon from '../photos/tiktok.png';
import igicon from '../photos/ig.png';

class About extends Component {
    constructor(props){
        super(props);

		this.appRef = createRef();
		this.titleRef = createRef();

		this.state = {
			width: 0,  // will be set on mount dynamically
			height: 0,
		};

		this.baseWidth = 0;  
  		this.baseHeight = 0;

		this.bringToFront = this.bringToFront.bind(this);
        this.closeApp = this.closeApp.bind(this);
    }

	componentDidMount() {
		const dragTarget = this.appRef.current; 
		const dragHandle = this.titleRef.current;
		const resizeHandle = dragTarget.querySelector('.resize-handle');
		
		// Measure initial size in pixels from actual DOM element
		const rect = dragTarget.getBoundingClientRect();
		
		this.baseWidth = rect.width;
  		this.baseHeight = rect.height;

		this.setState({
			width: rect.width,
			height: rect.height,
		});

		let isDragging = false;
		let isResizing = false;
		let startX = 0;
		let startY = 0;
		let initialLeft = 0;
		let initialTop = 0;
		let startWidth = 0;
		const DRAG_THRESHOLD = 5;

		// --- Drag logic ---
		const onMouseDown = (e) => {
			startX = e.clientX;
			startY = e.clientY;

			// Save the initial position of the window
			initialLeft = dragTarget.offsetLeft;
			initialTop = dragTarget.offsetTop;

			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseup', onMouseUp);
		};

		const onMouseMove = (e) => {
			const dx = e.clientX - startX;
			const dy = e.clientY - startY;

			// Only start dragging after threshold
			if (!isDragging && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
				isDragging = true;
			}

			if (!isDragging) return;

			// Update the window's position based on mouse movement delta
			dragTarget.style.left = `${initialLeft + dx}px`;
			dragTarget.style.top = `${initialTop + dy}px`;
		};

		const onMouseUp = () => {
			isDragging = false;
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};

		dragHandle.addEventListener('mousedown', onMouseDown);

		// --- Resize logic ---
		const onResizeMouseDown = (e) => {
			isResizing = true;
			startX = e.clientX;
			startY = e.clientY;
			startWidth = dragTarget.offsetWidth;

			document.addEventListener('mousemove', onResizeMouseMove);
			document.addEventListener('mouseup', onResizeMouseUp);

			e.preventDefault();
		};

		const aspectRatio = this.baseWidth / this.baseHeight;

		const MIN_WIDTH = 250;
		const MIN_HEIGHT = 200;
		const MAX_WIDTH = 500;
		const MAX_HEIGHT = 400;

		const onResizeMouseMove = (e) => {
			if (!isResizing) return;

			const deltaX = e.clientX - startX;
			const deltaY = e.clientY - startY;

			// Pick the dominant delta (horizontal or vertical)
			const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

			let newWidth = startWidth + delta;
			let newHeight = newWidth / aspectRatio;

			// Clamp width and height to both min and max
			newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, newWidth));
			newHeight = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, newHeight));

			this.setState({
				width: newWidth,
				height: newHeight,
			});
		};

		const onResizeMouseUp = () => {
			isResizing = false;
			document.removeEventListener('mousemove', onResizeMouseMove);
			document.removeEventListener('mouseup', onResizeMouseUp);
		};

		resizeHandle.addEventListener('mousedown', onResizeMouseDown);
	}
	
	bringToFront() {
		document.getElementById('cmdApp').style.zIndex = 1;
		document.getElementById('streamPageApp').style.zIndex = 1;
		document.getElementById('storePageApp').style.zIndex = 1;
		document.getElementById('aboutPageApp').style.zIndex = 2;
		document.getElementById('contactPageApp').style.zIndex = 1;
		document.getElementById('clipApp1').style.zIndex = 1;
		document.getElementById('clipApp2').style.zIndex = 1;
	}

    closeApp() {
		document.getElementById('aboutPageApp').style.zIndex = 1;
        document.getElementById('aboutPageApp').style.visibility = 'hidden';
    }

    render() { 
		const { width, height } = this.state;

		const baseWidth = this.baseWidth || 500;
        const baseHeight = this.baseHeight || 400;

		const scaleX = width / baseWidth;
		const scaleY = height / baseHeight;
		const scale = Math.min(scaleX, scaleY);

		const style = {
			overflow: 'hidden',
			...(this.state.width && this.state.height
				? { width: this.state.width, height: this.state.height }
				: {}) // fallback to CSS % sizing
		};

        return (
            <div 
				id='aboutPageApp' 
				ref={this.appRef}
				className="appWindow"
				onClick={this.bringToFront}
				style={style}
			>
                <div 
					id="cmdtitlearea"
					ref={this.titleRef}
				>
					<div id="aboutPage-title"> 
						<b> About MFKN </b>
					</div>
                    <div className='closeButton' onClick={this.closeApp}>X</div>
				</div>
                <div 
					id="cmdContentWrapper"
					style={{
					transform: `scale(${scale})`,
					transformOrigin: 'top left',
					width: baseWidth,
					height: baseHeight,
					position: 'relative',
					}}
				>
					<div id="aboutText">
						<pre>
	__    __     ______   __  __     __   __    	<br />
	/\ "-./  \   /\  ___\ /\ \/ /    /\ "-.\ \   	<br />
	\ \ \-./\ \  \ \  __\ \ \  _"-.  \ \ \-.  \  	<br />
	\ \_\ \ \_\  \ \_\    \ \_\ \_\  \ \_\\"\_\ 	<br />
	\/_/  \/_/   \/_/     \/_/\/_/   \/_/ \/_/ 	<br />
													<br />
			MFKN is a group focused on bringing together <br/>
			like-minded gamers and creative minds. <br/>
			Our aim is to create an innovative and inclusive space <br/>
			for gamers and creatives alike to share ideas, <br/>
			collaborate on projects, and create something amazing. <br/>
			We strive to create an environment in which people of <br/>
			all backgrounds and levels of experience can come <br/>
			together and be inspired by one another. <br/>
			Join us and help us shape the future!<br/>
			Links:
						</pre>
					</div>
					<div id="aboutText2">
						<pre>
																					<br/>
		    FROM THE ASHES! FROM THE ASHES! FROM THE ASHES! FROM THE ASHES!<br/>
															<br/>
						</pre>
					</div>
					<div id="aboutText3">
						<pre>
																	<br/>
		 ⣠⣴⣶⣿⣿⠿⣷⣶⣤⣄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⣴⣶⣷⠿⣿⣿⣶⣦⣀⠀⠀⠀⠀⠀     <br/>
	⠀⠀⠀⢀⣾⣿⣿⣿⣿⣿⣿⣿⣶⣦⣬⡉⠒⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠚⢉⣥⣴⣾⣿⣿⣿⣿⣿⣿⣿⣧⠀⠀⠀⠀<br/>
	⠀⠀⠀⡾⠿⠛⠛⠛⠛⠿⢿⣿⣿⣿⣿⣿⣷⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⣾⣿⣿⣿⣿⣿⠿⠿⠛⠛⠛⠛⠿⢧⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠻⣿⣿⣿⣿⣿⡄⠀⠀⠀⠀⠀⠀⣠⣿⣿⣿⣿⡿⠟⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢿⣿⡄⠀⠀⠀⠀⠀⠀⠀⠀⢰⣿⡿⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⣠⣤⠶⠶⠶⠰⠦⣤⣀⠀⠙⣷⠀⠀⠀⠀⠀⠀⠀⢠⡿⠋⢀⣀⣤⢴⠆⠲⠶⠶⣤⣄⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠘⣆⠀⠀⢠⣾⣫⣶⣾⣿⣿⣿⣿⣷⣯⣿⣦⠈⠃⡇⠀⠀⠀⠀⢸⠘⢁⣶⣿⣵⣾⣿⣿⣿⣿⣷⣦⣝⣷⡄⠀⠀⡰⠂⠀<br/>
	⠀⠀⣨⣷⣶⣿⣧⣛⣛⠿⠿⣿⢿⣿⣿⣛⣿⡿⠀⠀⡇⠀⠀⠀⠀⢸⠀⠈⢿⣟⣛⠿⢿⡿⢿⢿⢿⣛⣫⣼⡿⣶⣾⣅⡀⠀<br/>
	⢀⡼⠋⠁⠀⠀⠈⠉⠛⠛⠻⠟⠸⠛⠋⠉⠁⠀⠀⢸⡇⠀⠀⠄⠀⢸⡄⠀⠀⠈⠉⠙⠛⠃⠻⠛⠛⠛⠉⠁⠀⠀⠈⠙⢧⡀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣿⡇⢠⠀⠀⠀⢸⣷⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀		<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣾⣿⡇⠀⠀⠀⠀⢸⣿⣷⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀		<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣰⠟⠁⣿⠇⠀⠀⠀⠀⢸⡇⠙⢿⣆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀		<br/>
																<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀      ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀		       <br/>
	⠀⠀⢻⣷⡦⣤⣤⣤⡴⠶⠿⠛⠉⠁⠀⢳⠀⢠⡀⢿⣀⠀⠀⠀⠀⣠⡟⢀⣀⢠⠇⠀⠈⠙⠛⠷⠶⢦⣤⣤⣤⢴⣾⡏   <br/>
	⠀⠀⠈⣿⣧⠙⣿⣷⣄⠀⠀⠀⠀⠀⠀⠀⠀⠘⠛⢊⣙⠛⠒⠒⢛⣋⡚⠛⠉⠀⠀⠀⠀⠀⠀⠀⠀⣠⣿⡿⠁⣾⡿⠀⠀⠀<br/>
	⠀⠀⠀⠘⣿⣇⠈⢿⣿⣦⠀⠀⠀⠀⠀⠀⠀⠀⣰⣿⣿⣿⡿⢿⣿⣿⣿⣆⠀⠀⠀⠀⠀⠀⠀⢀⣼⣿⡟⠁⣼⡿⠁⠀⠀⠀<br/>
	⠀⠀⠀⠀⠘⣿⣦⠀⠻⣿⣷⣦⣤⣤⣶⣶⣶⣿⣿⣿⣿⠏⠀⠀⠻⣿⣿⣿⣿⣶⣶⣶⣦⣤⣴⣿⣿⠏⢀⣼⡿⠁⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠘⢿⣷⣄⠙⠻⠿⠿⠿⠿⠿⢿⣿⣿⣿⣁⣀⣀⣀⣀⣙⣿⣿⣿⠿⠿⠿⠿⠿⠿⠟⠁⣠⣿⡿⠁⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠈⠻⣯⠙⢦⣀⠀⠀⠀⠀⠀⠉⠉⠉⠉⠉⠉⠉⠉⠉⠉⠉⠉⠀⠀⠀⠀⠀⣠⠴⢋⣾⠟⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠙⢧⡀⠈⠉⠒⠀⠀⠀⠀⠀⠀⣀⠀⠀⠀⠀⢀⠀⠀⠀⠀⠀⠐⠒⠉⠁⢀⡾⠃⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⣄⠀⠀⠀⠀⠀⠀⠀⠀⠻⣿⣿⣿⣿⠋⠀⠀⠀⠀⠀⠀⠀⠀⣠⠟⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⢦⡀⠀⠀⠀⠀⠀⠀⠀⣸⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀⢀⡴⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⣿⣿⠀⠀⠀⠀⠀⠀⠀⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠐⣿⣿⣿⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⣿⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢻⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
	⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠸⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀<br/>
						</pre>
					</div>
					<div id="linkBlocker"></div>
					{<a href="https://www.instagram.com/mfkn_ak/" target="_blank" rel="noreferrer"> 
						<div id="igicondiv">
							<img id="igicon" src={igicon} alt="icon"></img>
						</div>
					</a>}
					{/*<a href="https://www.tiktok.com/@mfkn_ak00" target="_blank" rel="noreferrer"> 
						<div id="tiktokicondiv">
							<img id="tiktokicon" src={tiktokicon} alt="icon"></img>
						</div>
					</a>*/}
					<a href="https://discord.gg/zR2fEWKSKP" target="_blank" rel="noreferrer">
						<div id="discordicondiv">
							<img id="discordicon" src={discordicon} alt="icon"></img>
						</div>
					</a>
				</div>
				<div className="resize-handle" />
            </div>
        );
    }
}
 
export default About;

